<template>
    <div class='visual-pointer'>
        <svg class="visual-pointer__svg-canvas" :viewBox="[`0 0 ${renderSize.width} ${renderSize.height}`]"
             preserveAspectRatio="xMidYMid slice">
            <template v-for="pointer in pointers">
                <svg
                    :x="[pointer.left ? pointer.left : 0]"
                    :y="[pointer.top ? pointer.top : 0]"
                    :key=pointer.id
                    ref="anchor"
                ></svg>
            </template>
            <template v-for="element in elements">
                <svg v-if="element.pointer"
                    :x="[element.pointer.left ? element.pointer.left : 0]"
                    :y="[element.pointer.top ? element.pointer.top : 0]"
                    :key="element.pointer.id"
                    ref="anchorLink"
                ></svg>
            </template>
        </svg>
        <template v-for="pointer in pointers">
            <div
                v-if="pointer.reposition.top"
                :class="[{ 'visual-pointer__item_theme_floor': pointer.floor }, 'visual-pointer__item']"
                :key=pointer.id
                :style="{ top: pointer.reposition.top, left: pointer.reposition.left}"
                ref="pointers"
            >{{pointer.text}}</div>
        </template>
        <template v-for="element in elements">
            <div v-if="element.pointer"
                 :key=element.pointer.id
                 :class="[{ 'visual-pointer__item_theme_floor': element.pointer.floor },
                         'visual-pointer__item visual-pointer__item_theme_click']"
                 :link=element.link
                 :style="{ top: element.pointer.reposition.top, left: element.pointer.reposition.left}"
                 @mouseover="mouseOverHandler(element.id, element.link, $event)"
                 @mousemove="mouseMoveHandler"
                 @mouseleave="mouseLeaveHandler"
                 @click="clickHandler(element.link)"
                 ref="pointersLink"
            >{{element.pointer.text}}</div>
        </template>
    </div>
</template>

<style lang='scss'>
    @import "./Pointer.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import Observer from 'common/scripts/observer';
import reposition from '../../helpers/reposition';
import Utils from 'common/scripts/utils';

const observer = new Observer();

export default {
    data() {
        return {
            clickCount: 0
        };
    },

    computed: {
        ...mapGetters({
            elements  : 'GET_ELEMENTS',
            pointers  : 'GET_POINTERS',
            renderSize: 'GET_CANVAS_SIZE',
            rotate    : 'GET_ROTATE',
            dataStep  : 'GET_DATA_STEP'
        })
    },

    created() {
        this.bindEvents();
    },

    methods: {
        ...mapActions(['changePosition', 'changeElementsPosition']),

        bindEvents() {
            observer.subscribe('changePointer', () => {
                this.position();
            });
        },

        /**
         * Метод позиционирует поинтеры согласно координатам svg-якорей.
         */
        position() {
            if (this.pointers && this.pointers.length) {
                const coords = reposition(this.$refs.anchor);

                this.changePosition({
                    type: 'pointers',
                    coords
                });
            }

            let index = 0;

            for (const element in this.elements) {
                if (this.elements.hasOwnProperty(element) && this.elements[element].pointer) {
                    const coords = reposition(this.$refs.anchorLink)[index];
                    const id = this.elements[element].id;

                    this.changeElementsPosition({
                        id,
                        coords
                    });

                    index++;
                }
            }
        },

        mouseOverHandler(id, link, event) {
            this.overlay = this.$appOptions.overlay.hover;

            if (Utils.isBreakpoint(0, 1280)) {
                observer.publish('mouseoverPanel', {
                    id,
                    link,
                    event,
                    elements: this.elements,
                    type    : 'flats'
                });
            } else {
                observer.publish('mouseoverTooltip', {
                    id,
                    event,
                    elements: this.elements,
                    type    : 'flats'
                });
            }
        },

        mouseMoveHandler(event) {
            if (!Utils.isBreakpoint(0, 1280)) {
                observer.publish('mousemoveTooltip', event);
            }
        },

        mouseLeaveHandler() {
            this.overlay = this.$appOptions.overlay.default;

            if (Utils.isBreakpoint(0, 1280)) {
                observer.publish('mouseleavePanel');
                this.clickCount = 0;
            } else {
                observer.publish('mouseleaveTooltip');
            }
        },

        clickHandler(link) {
            if (Utils.isBreakpoint(0, 1280)) {
                this.clickCount = this.clickCount + 1;
                if (this.clickCount % 2 === 0) {
                    this.route(link);
                }
            } else {
                observer.publish('mouseclickTooltip');
                this.route(link);
            }
        },

        route(link) {
            if (this.dataStep.step === 'flat') {
                window.location = link;
            } else {
                this.$router.push(link);
            }
        }
    },

    watch: {
        rotate() {
            this.$nextTick(() => {
                this.position();
            });
        }
    },

    mounted() {
        this.position();

        window.addEventListener('resize', this.position);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.position);
    }
};
</script>
